<script lang="ts" setup>
import type { SpacingSchema } from '@integration-layer/ampliance/schemas/spacing-schema-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: SpacingSchema
}>()

const data = await useComponentResponse<SpacingSchema>(props)
</script>

<template>
  <div class="offset-height"></div>
</template>

<style lang="scss" scoped>
.offset-height {
  margin-top: var(--header-default-height);
}
</style>
